import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Tooltip = lazyImport(() => import('@mui/material/Tooltip'))